function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_14570_2283)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.8644 0.371582C15.0657 0.371582 13.4508 1.30751 13.4508 3.02497C13.4508 5.00295 16.3035 5.13804 16.3035 6.1222C16.3035 6.5371 15.82 6.91339 15.0077 6.91339C13.8473 6.91339 12.9769 6.39237 12.9769 6.39237L12.6095 8.12913C12.6095 8.12913 13.6055 8.57297 14.94 8.57297C16.9127 8.57297 18.46 7.59845 18.46 5.84239C18.46 3.75827 15.5976 3.62319 15.5976 2.70657C15.5976 2.37851 15.9941 2.02151 16.8064 2.02151C17.725 2.02151 18.4793 2.39781 18.4793 2.39781L18.8468 0.718935C18.8371 0.718935 18.0151 0.371582 16.8644 0.371582ZM0.386242 0.497015L0.337891 0.747881C0.337891 0.747881 1.09217 0.882963 1.77876 1.16277C2.65876 1.48118 2.71678 1.66451 2.8715 2.23378L4.48644 8.43789H6.65258L9.96948 0.497015H7.81301L5.67588 5.90028L4.80556 1.31715C4.72819 0.796124 4.32204 0.497015 3.81919 0.497015H0.386242ZM10.8398 0.497015L9.14751 8.43789H11.2073L12.8899 0.497015H10.8398ZM22.3087 0.497015C21.8156 0.497015 21.5545 0.75753 21.3611 1.22067L18.3439 8.43789H20.5004L20.9162 7.2318H23.5465L23.798 8.43789H25.703L24.0494 0.497015H22.3087ZM22.5892 2.64867L23.2274 5.63012H21.5158L22.5892 2.64867Z",
  fill: "#1434CB"
}));
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_14570_2283"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25.3651,
  height: 8.20139,
  fill: "white",
  transform: "translate(0.337891 0.371582)"
})));
const SvgVisaCard = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 19,
    viewBox: "0 0 26 9",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVisaCard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/visa-card.4801042b.svg";
export { ForwardRef as ReactComponent };